export const createActiveAlerts = (alerts: any) => {
  if(alerts) {
    return alerts.reduce((acc: any[], alert: any) => {
      if(!alert.cleared) {
        acc.push(alert);
      }
      return acc;
    }, [])
  } else return [];
}






// WEBPACK FOOTER //
// ./src/utils/alerts/createActiveAlerts.ts